import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=bf28525e&scoped=true&"
import script from "./GetStarted.vue?vue&type=script&lang=js&"
export * from "./GetStarted.vue?vue&type=script&lang=js&"
import style0 from "./GetStarted.vue?vue&type=style&index=0&id=bf28525e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf28525e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf28525e')) {
      api.createRecord('bf28525e', component.options)
    } else {
      api.reload('bf28525e', component.options)
    }
    module.hot.accept("./GetStarted.vue?vue&type=template&id=bf28525e&scoped=true&", function () {
      api.rerender('bf28525e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/GetStarted.vue"
export default component.exports